// Constants equivalent in JavaScript

// SerializerKind Enum Equivalent
export enum SerializerKind {
    GEOM = 'geom',
    BINARY_DATA = 'binary',
}
